import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / form controls follow the active theme.
    colorScheme: theme.palette.type,
  },
  title: {
    fontSize: '23px',
    marginLeft: '2%',
    marginTop: '5%',
    color: theme.palette.primary.mainBlue,
    width: '100%',
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    color: theme.palette.primary.gray,
    marginLeft: '2%',
  },
  dropZone: {
    border: `2px dashed ${theme.palette.custom.dropzoneBorder}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.custom.dropzoneBackground,
    margin: '0 auto',
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    width: '75vw',
    height: '70vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    cursor: 'pointer',
  },
  cloud: {
    marginBottom: theme.spacing(2),
  },
  tableWrapper: {
    margin: theme.spacing(2),
    width: '75vw',
    '& .MuiTableHead-root': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiTableCell-head': {
        color: theme.palette.primary.white,
        fontWeight: 'bold',
      },
    },
  },
  deleteIcon: {
    // MUI's own error red, which is the literal this replaced (#f44336).
    color: theme.palette.error.main,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    paddingRight: '3%',
    paddingTop: '1%',
  },
  botonCargar: {
    // Was `primary.mainBlue`, which is a text token and turns light blue in dark
    // mode — unusable behind a white label.
    backgroundColor: theme.palette.custom.brandButtonBackground,
    width: '100px',
    color: theme.palette.custom.solidButtonText,
    '&:hover': {
      backgroundColor: theme.palette.secondary.bluegray,
    },
  },
  botonCancelar: {
    color: theme.palette.custom.errorText,
    width: '100px',
    '&:hover': {
      backgroundColor: theme.palette.primary.error,
      color: theme.palette.custom.solidButtonText,
    },
    borderColor: theme.palette.primary.error,
  },
}));

export default useStyles;
